import {
  type GridFilterModel,
  type GridPaginationModel,
  type GridSortModel,
} from '@mui/x-data-grid-pro';

import { serializeFilterModel, serializePagination, serializeSortModel } from './serializers';

// Utility to build query string from state
export function buildQueryString({
  paginationModel,
  sortModel,
  filterModel,
}: {
  paginationModel?: GridPaginationModel;
  sortModel?: GridSortModel;
  filterModel?: GridFilterModel;
  additionalQueryArgs?: string;
}) {
  const serializedPaginationModel = serializePagination(paginationModel);
  const serializedSortModel = serializeSortModel(sortModel);
  const serializedFilterModel = serializeFilterModel(filterModel);

  const params = new URLSearchParams();
  serializedPaginationModel && params.set('page', (serializedPaginationModel.page + 1).toString());
  serializedPaginationModel &&
    params.set('pageSize', serializedPaginationModel.pageSize.toString());
  serializedSortModel && params.set('sort', serializedSortModel);
  serializedFilterModel?.filter && params.set('filter', serializedFilterModel.filter);
  serializedFilterModel?.logicOperator &&
    params.set('logicOperator', serializedFilterModel.logicOperator || 'and');
  // Only set quickFilter if it's a non-empty string
  if (serializedFilterModel?.quickFilter && serializedFilterModel.quickFilter.trim()) {
    params.set('quickFilter', serializedFilterModel.quickFilter);
  }
  serializedFilterModel?.quickFilterLogicOperator &&
    params.set('quickFilterLogicOperator', serializedFilterModel.quickFilterLogicOperator || 'and');

  return params.toString();
}
